/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressDtoFromJSON, AddressDtoToJSON, } from './AddressDto';
import { BountyLocationFromJSON, BountyLocationToJSON, } from './BountyLocation';
import { IncidentReportTypeFromJSON, IncidentReportTypeToJSON, } from './IncidentReportType';
/**
 * Check if a given object implements the IncidentReportDetailsDto interface.
 */
export function instanceOfIncidentReportDetailsDto(value) {
    let isInstance = true;
    return isInstance;
}
export function IncidentReportDetailsDtoFromJSON(json) {
    return IncidentReportDetailsDtoFromJSONTyped(json, false);
}
export function IncidentReportDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'incidentReportType': !exists(json, 'incidentReportType') ? undefined : IncidentReportTypeFromJSON(json['incidentReportType']),
        'hasContentWarning': !exists(json, 'hasContentWarning') ? undefined : json['hasContentWarning'],
        'isFilmedInPublicLocation': !exists(json, 'isFilmedInPublicLocation') ? undefined : json['isFilmedInPublicLocation'],
        'userConsentProvided': !exists(json, 'userConsentProvided') ? undefined : json['userConsentProvided'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'location': !exists(json, 'location') ? undefined : BountyLocationFromJSON(json['location']),
        'address': !exists(json, 'address') ? undefined : AddressDtoFromJSON(json['address']),
        'incidentDateTime': !exists(json, 'incidentDateTime') ? undefined : (json['incidentDateTime'] === null ? null : new Date(json['incidentDateTime'])),
        'incidentTimezone': !exists(json, 'incidentTimezone') ? undefined : json['incidentTimezone'],
        'userSubmittedIncidentDescription': !exists(json, 'userSubmittedIncidentDescription') ? undefined : json['userSubmittedIncidentDescription'],
        'primaryUserIncidentFileId': !exists(json, 'primaryUserIncidentFileId') ? undefined : json['primaryUserIncidentFileId'],
    };
}
export function IncidentReportDetailsDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'incidentReportType': IncidentReportTypeToJSON(value.incidentReportType),
        'hasContentWarning': value.hasContentWarning,
        'isFilmedInPublicLocation': value.isFilmedInPublicLocation,
        'userConsentProvided': value.userConsentProvided,
        'countryCode': value.countryCode,
        'location': BountyLocationToJSON(value.location),
        'address': AddressDtoToJSON(value.address),
        'incidentDateTime': value.incidentDateTime === undefined ? undefined : (value.incidentDateTime === null ? null : value.incidentDateTime.toISOString()),
        'incidentTimezone': value.incidentTimezone,
        'userSubmittedIncidentDescription': value.userSubmittedIncidentDescription,
        'primaryUserIncidentFileId': value.primaryUserIncidentFileId,
    };
}
